// extracted by mini-css-extract-plugin
export default {"wrapper":"CenturionLogo_wrapper__T8a2s"};